import clsx from "clsx";
import React from "react";
import PropTypes from "prop-types";
import Icon from "./../Icon";

const Tab = ({ label, index, icon, onClick, selected, disabled }) => {
    return (
        <div
            className={clsx("tab", { "tab--active": selected, "tab--disabled": disabled })}
            key={index}
            onClick={disabled ? undefined : onClick}
        >
            <Icon name={icon} color="grey" size="sm" />
            <span className="tab__label">{label}</span>
        </div>
    );
};

Tab.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number,
    icon: PropTypes.string,
    label: PropTypes.node,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
};

Tab.defaultProps = {
    children: "",
    index: 0,
    icon: "",
    label: "",
    onClick: undefined,
    selected: false,
    disabled: false,
};

export default Tab;
